var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-tools" }, [
    _c(
      "button",
      {
        staticClass: "main-tools--item graphic-tool-button tooltip-add-text",
        on: { click: _vm.addText }
      },
      [
        _c("span", { staticClass: "graphic-tool-button__icon icon-text" }),
        _vm._v(" "),
        _c("span", { staticClass: "graphic-tool-button__name" }, [
          _vm._v("テキストボックス")
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "main-tools--item graphic-tool-button tooltip-add-image" },
      [
        _c("span", {
          staticClass:
            "graphic-tool-button__icon graphic-tool-button__icon--large fi-photo"
        }),
        _vm._v(" "),
        _c("span", { staticClass: "graphic-tool-button__name" }, [
          _vm._v("画像")
        ]),
        _vm._v(" "),
        _c("input", {
          staticStyle: { display: "none" },
          attrs: {
            type: "file",
            accept: "image/jpeg,image/png,image/gif",
            multiple: ""
          },
          on: { change: _vm.onFileUploaded }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "main-tools--item graphic-tool-button tooltip-add-embed",
        on: { click: _vm.addEmbed }
      },
      [
        _c("span", { staticClass: "graphic-tool-button__icon icon-embed" }),
        _vm._v(" "),
        _c("span", { staticClass: "graphic-tool-button__name" }, [
          _vm._v("埋め込みコード")
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "main-tools--item graphic-tool-button tooltip-add-url",
        on: { click: _vm.addUrl }
      },
      [
        _c("span", {
          staticClass:
            "graphic-tool-button__icon graphic-tool-button__icon--large fi-link"
        }),
        _vm._v(" "),
        _c("span", { staticClass: "graphic-tool-button__name" }, [
          _vm._v("埋め込みURL")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }